import React from 'react';
import { useFormik } from 'formik';
import _ from 'lodash';
// import { useLocation } from 'react-router-dom'

import {
  Row,
  Col,
  Form,
} from 'react-bootstrap';
import styled from 'styled-components';
import { up, down } from 'styled-breakpoints';

import { Spin } from "antd";

// Auth
// import { useAuthContext } from '../../../v5/auth/use-auth-context.js';
import { useRouter } from '../../../v5/auth/auth-guard.js';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector, Tables } from '../../../v5/utils/store.tsx';
import slice, { FormikContext, fields, initialValues, customerSiteInit, findStatus, formatCustomerSiteAddress, concatStringRemarks, formSchema, prepareForm, prepareData, saveJobForm, saveAction, reloadAction, setPricingItemWithoutService, setPricingItem, setPricingsData, margePricingsData, getId, isEdit, isCopy, setQtyAtMainPricings, getJobFormActionButtons, updateBundleServiceTagsAfterAdd, updateBundleServiceTagsAfterDelete, updateBillingPricings, jobBinTypesOrder, clearForm } from './slice.tsx';
import confirmSlice from '../../../v5/components/modal/confirmSlice.tsx';

// enums
import { getIntProps, updateRow, createRow, getMaxPageSize, isNumeric, getBoolProps, getUser } from '../../../v5/utils/utils.tsx';
import { MAIN_BREAKPOINT, Permissions, ProformaPaymentType } from '../../../v5/utils/enums.tsx';

// components
import MainContainer from '../../../v5/components/container/MainContainer.jsx';
import createGenericSlice, { BackOptions } from '../../../v5/components/table/withSlice/tableSlice.tsx';

import billingJobSlice, { ServiceType } from './form/billingJob/slice.tsx';
import { smartConversionKgTons } from './form/weightChit/slice.tsx';
import { LocalJobType, ForWith, canDoPricings, getBinsForPricings, LocationEnum, getFirstCustomerSite } from '../manage/jobs/jobTypes/slice.tsx';
import proformaInvoiceSlice, { getTotal } from './form/proformaInvoice/slice.tsx';
import servicesSlice from './form/services/slice.tsx';

import Header from './form/Header.tsx';
import Footer from './form/Footer.tsx';
import PrintPreview from './form/printPreview/Page.tsx';
import ProformaInvoice from './form/proformaInvoice/Page.tsx';
import RecurringJob from './form/recurringJob/Page.tsx';
import BillingJob from './form/billingJob/Page.tsx';
import WeightChit from './form/weightChit/Page.tsx';
import JobRoutes from './form/JobRoutes.tsx';
import JobSummary from './form/jobSummary/Page.tsx';
import DefaultLocation from './form/defaultLocation/Form.tsx';
import Alerts from './form/Alerts.tsx';
import CustomerDetails from './form/CustomerDetails.tsx';
import JobType from './form/JobType.tsx';
import JobTypeHistory from './form/jobTypeHistory/Page.tsx';
import Location from './form/Location.tsx';
import BinDetails from './form/BinDetails.tsx';
import Services from './form/services/Page.tsx';
import DispatchOrder from './form/DispatchOrder.tsx';
import DriverOptions from './form/driverOptions/Page.tsx';
import Payment from './form/Payment.tsx';
import Attachments from './form/Attachments.tsx';
import Signature from './form/Signature.tsx';
import AuditTrailList from './form/AuditTrail.tsx';
import AuditTrail from './form/auditTrail/Page.tsx';
import AuditTrailDriverTrackng from './form/auditTrail/driverTrackng/Page.tsx';
import DeleteJob from './form/delete/Form.tsx';

import ServicesForm from "../services/Form.tsx";
// import servicesSlice from "../services/slice.tsx";

import CustomerMiniForm from "./form/customer/Form.tsx";
// import customerMiniSlice from "./form/customer/slice";

import CustomerSiteMiniForm from "./form/customerSite/Form";
// import customerSiteMiniSlice from "./form/customerSite/slice";

// import { ReactComponent as XIcon } from "../../../v5/assets/icons/smallX.svg";

import SignalR from "../../../components/signalR/SignalR.jsx";
import { ReceiveMessage } from "../../../components/signalR/Enums.jsx";

const { REACT_APP_REAL_TIME_URL } = process.env;

// ----------------------------------------------------------------------

const StyledLayoutWrapper = styled.div`
  width: 100%;
  display: inline-block;

  ${up('lg')} {
    height: calc(100vh - var(--header-height, 64px) - 5px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  ${down('lg')} {
    width: 100%;
  }

  .top-section {
    border-bottom: 1px solid var(--bs-gray-100);
    z-index: 1;

    ${up('lg')} {
      position: sticky;
      top: 0px;
      padding: 20px 32px;
    }
  
    ${down('lg')} {
      position: relative;
      padding: 20px 16px;
    }
  }

  .content-section {
    width: 100%;

    ${up('lg')} {
      display: inline-flex;
      height: calc(100vh - var(--header-height, 64px) - var(--job-form-top-height, 72px) - var(--job-form-footer-height, 72px) - 7px);
      padding: 24px 32px;
    }
  
    ${down('lg')} {
      display: block;
      height: auto;
      padding: 24px 16px;
    }

    .form-section {
      ${up('xl')} {
        overflow: auto;
      }

      ${up('lg')} {
        width: calc(100% - 470px);
      }
    
      ${down('lg')} {
        width: 100%;
        margin-bottom: 32px;
      }

      > div {
        width: 100%;

        > div {
          padding-right: 0px;
          justify-items: center;
          
          > div {
            width: 100%;

            > div {
              ${down('lg')} {
                padding-right: 0px;
              }
            }
          }
        }
      }

      .ant-divider {
        margin: 16px 0px 0px 0px;
      }
    }

    .side-section {
      overflow: auto;
      
      ${up('lg')} {
        width: 470px;
      }
    
      ${down('lg')} {
        width: 100%;
      }

      > div {
        width: 100%;

        > div {
          padding-right: 0px;
          justify-items: flex-end;

          ${down('lg')} {
            justify-items: center;
          }
          
          > div {
            width: 100%;

            > div {
              padding-right: 0px;
            }
          }
        }
      }
    }
  }

  .footer-section {
    border-top: 1px solid var(--bs-gray-100);
    position: sticky;
    bottom: 0px;
    background-color: white;
    z-index: 2;
    
    ${up('lg')} {
      padding: 20px 32px;
    }
  
    ${down('lg')} {
      padding: 20px 16px;
    }
  }
`;


// const table = createGenericSlice<any>(Tables.Jobs);

const FormComponent = () => {
  // const location = useLocation();
  const router = useRouter();

  const topHeight = document.getElementById('top_ID')?.clientHeight || 72;
  const footerHeight = document.getElementById('footer_ID')?.clientHeight || 72;
  document.documentElement.style.setProperty('--job-form-top-height', `${(topHeight)}px`);
  document.documentElement.style.setProperty('--job-form-footer-height', `${(footerHeight)}px`);

  // const { user }: any = useAuthContext();
  // const { userAccount } = user ?? {};
  // const someField = userAccount?.someField;

  const { isLoading, details, isLoadingCreateUpdateDelete, isLoadingCreditLimit, isCreditLimit, isLoadingJobTemplates, isLoadingDownloadInternalNote, isLoadingRefreshJobNote } = useTypedSelector((state: RootState) => state.jobFormSlice);
  const { isLoadingServicesItems } = useTypedSelector((state: RootState) => state.jobFormBinDetailsServicesSlice);
  const { show } = useTypedSelector((state: RootState) => state.jobFormProformaInvoiceSlice);
  // const { tableData, tableTotal } = useTypedSelector((state: RootState) => state.tableJobs);
  const dispatch = useDispatch<AppDispatch>();

  const [backLink, _setBackLink] = React.useState<any>('/jobs');

  const jobTypeRef = React.useRef<any>(null);
  const serviceListRef = React.useRef<any>(null);

  const [weightChitCounter, setWeightChitCounter] = React.useState<number>(1);

  let user = getUser();
  let groupAccountEmail = user && user.userAccount && user.userAccount.accountEmail ? user.userAccount.accountEmail : "";
  let userEmail = user && user.email && user.email !== "" ? user.email : "";


  React.useEffect(() => {
    onResetSlice();

    setTimeout(() => {
      let id = getId();
      if(id && id > 0){
        dispatch(slice.callDetailsApi(id, (state: boolean, data: any) => {
          if(state && data && data.version === 0){
            router.push('/jobs-form?id=' + id)
          }
        }));
      } else {
        setTimeout(() => {
          setErrors({});
        }, 0);
      }
      
      dispatch(slice.callLatestLocationDriversApi([], (state: Boolean, data: any) => {}));
  
      let params = {
        currentPage: 1,
        pageSize: getMaxPageSize(),
        sortColumn: 'locationName',
        sortDir: 'asc',
      };
      dispatch(slice.callReadDefaultLocationApi(params, (state: boolean, data: any) => {}));
    }, 0);

    return () => {
      onResetSlice();
    };
  }, []);

  React.useEffect(() => {
    dispatch(slice.setLoading(true));
    let form = prepareForm(details, initialValues);
    setValues(form);
    setTimeout(() => {
        setErrors({});
    }, 0);
    dispatch(slice.setLoading(false));

    
    let id = getId();
    let isProformaInvoice = getBoolProps(null, 'profoerma-invoice');
    if(isProformaInvoice && (id && id > 0) && details && !show){
      // dispatch(proformaInvoiceSlice.setShow({ show: true, form: form }));
      dispatch(billingJobSlice.setShow({ show: true, form: form }));
    }
  }, [details]);

  React.useEffect(() => {
    if(isEdit() && !isCopy() && weightChitCounter > 1){
      let actions = getJobFormActionButtons(values);
      let main = actions ? actions.main : null;
      onUpdateWeightChit(main);
    }
  }, [weightChitCounter]);


  const formik = useFormik({
    initialValues: initialValues,
    validateOnMount: false,
    validateOnChange: true,
    validationSchema: formSchema(),
    onSubmit: values => {},
  });
  const { values, errors, setValues, setFieldValue, setErrors, validateForm, handleSubmit }: any = formik;
  

  const onResetSlice = () => {
    let form = prepareForm(null, initialValues);
    setValues(form);
    dispatch(slice.setValues(form));
    dispatch(slice.setIsJobUpdated(false));
    dispatch(slice.resetSlice());
  }
  const onCancel = (backOptions: number = BackOptions.Read, data: any = null) => {
    onResetSlice();
    
    if(backOptions === BackOptions.Create){
      router.pushArgs(backLink, { backOptions: backOptions, backData: data });
    } else if(backOptions === BackOptions.Update){
      router.pushArgs(backLink, { backOptions: backOptions, backData: data });
    } else {
      router.push(backLink);
    }
  }


  const onCreate = (eventKey: any) => {
    let data = prepareData(values, eventKey, null);
    dispatch(slice.callCreateApi(data, (state: boolean, data: any) => {
      if(state){
        // let rows = createRow(tableData, 'jobId', { ...data, isNew: true });
        // dispatch(table.callSetData({ data: rows, total: (tableTotal+1)}));
        // onCancel(BackOptions.Create, data);
        let jobId = (data && data.length > 0 && data[0]) ? data[0].jobId : null;
        saveAction(eventKey, jobId, router, null);
      }
    }));
  }
  const onUpdate = (eventKey: any, cancellationRemarks = null) => {
    let data = prepareData(values, eventKey, cancellationRemarks);
    dispatch(slice.callUpdateApi(data, (state: boolean, data: any) => {
      if(state){
        // let rows = updateRow(tableData, 'jobId', { ...data, isNew: false });
        // dispatch(table.callSetData({ data: rows, total: tableTotal}));
        // onCancel(BackOptions.Update, data);
        saveAction(eventKey, getId(), router, () => {
          dispatch(slice.callDetailsApi(getId(), (state: boolean, data: any) => {}));
        });
      }
    }));
  }
  const onUpdateWeightChit = (eventKey: any) => {
    let data = prepareData(values, eventKey, null);
    dispatch(slice.callUpdateApi(data, (state: boolean, data: any) => {
      if(state){
        // let rows = updateRow(tableData, 'jobId', { ...data, isNew: false });
        // dispatch(table.callSetData({ data: rows, total: tableTotal}));
        // onCancel(BackOptions.Update, data);
        reloadAction(getId(), router, () => {
          dispatch(slice.callDetailsApi(getId(), (state: boolean, data: any) => {}));
        });
      }
    }));
  }
  const onCopy = (eventKey: any) => {
    let data = prepareData(values, eventKey, null);
    dispatch(slice.callCreateApi(data, (state: boolean, data: any) => {
      if(state){
        // let rows = createRow(tableData, 'jobId', { ...data, isNew: true });
        // dispatch(table.callSetData({ data: rows, total: (tableTotal+1)}));
        // onCancel(BackOptions.Create, data);
        let jobId = (data && data.length > 0 && data[0]) ? data[0].jobId : null;
        reloadAction(jobId, router, () => {
          dispatch(slice.callDetailsApi(jobId, (state: boolean, data: any) => {
            if(state){
              router.changeParamsInUrl('id=' + jobId);
            }
          }));
        });
      }
    }));
  }
  const onDelete = (remarks: any) => {
    let data = {
      jobId: getId(),
      remarks: remarks,
    };
    dispatch(slice.callDeleteApi(data, (state: boolean, data: any) => {
      if(state){
        // let rows = createRow(tableData, 'jobId', { ...data, isNew: true });
        // dispatch(table.callSetData({ data: rows, total: (tableTotal+1)}));
        // onCancel(BackOptions.Create, data);
        saveAction(null, null, router, null);
      }
    }));
  }


  const onSelectBin = async (groupIndex: number, blockIndex: number, index: number, selectedItem: any, mainItem: any, additionalItems: Array<any>, isSelectedInPopup: boolean = true) => {
    if(isNumeric(groupIndex) && isNumeric(blockIndex) && isNumeric(index) && mainItem){
      let wasteTypes: Array<any> = [];
      if(additionalItems && additionalItems.length > 0){
        additionalItems.forEach((x: any, j: number) => {
          wasteTypes.push({
            ...x,
            order: (j+1),
          });
        });
      }
      

      let itm = _.cloneDeep(values.stepGroups[groupIndex].blocks[blockIndex].bins[index]);
      let obj = {
        ...itm,
        serviceItem: mainItem,
        serviceItemId: mainItem?.serviceItemId,
        binTypeId: mainItem?.binTypeId,
        binType: mainItem?.binType,
        isNoninventory: mainItem?.binType?.isNoninventory,
        wasteTypeId: mainItem?.wasteTypeId,
        wasteType: mainItem?.wasteType,
        wasteTypes: wasteTypes,
        binNumberId: (selectedItem) ? selectedItem?.binNumberId : mainItem?.binNumberId,
        binNumber: (selectedItem) ? selectedItem?.binNumber : mainItem?.binNumber,
        quantity: isSelectedInPopup ? 1 : mainItem?.quantity,
        binOutWeight: null,
        binWeight: null,
        tareBinWeight: null,
        netBinWeight: null,
        nonBillableBinWeight: null,
        billableBinWeight: null,
        weightChitTicketNumber: null,
        weightChitRemarks: null,
        binWeighBy: null,
        weightChitDateTime: null,
        weightChitOutDateTime: null,
      }
      await setFieldValue('stepGroups.' + groupIndex + '.blocks.' + blockIndex + '.bins.' + index, obj);

      let order = jobBinTypesOrder(values, groupIndex, blockIndex, index, obj);

      let shouldDoPricings = canDoPricings(values.stepGroups[groupIndex], values.stepGroups[groupIndex].blocks[blockIndex]);
      if(shouldDoPricings && mainItem?.serviceItemId != itm?.serviceItemId){
        let oldPricings = (values.pricings && values.pricings.length > 0) ? _.cloneDeep(values.pricings) : [];

        oldPricings = oldPricings.filter((x: any) => x.bundleServiceTag != itm?.serviceItem?.serviceTag + '_' + order);

        let newPricings = setPricingsData(mainItem, additionalItems, order, false);
        let pricings = margePricingsData(oldPricings, newPricings);
        await setFieldValue('pricings', pricings);

        let amountToCollect = calcAmountToCollectFromPricings(pricings);
        await setFieldValue('amountToCollect', amountToCollect);
      }
    }
  }
  const onSelectTask = async (groupIndex: number, blockIndex: number, index: number, mainItem: any, additionalItems: Array<any>, isSelectedInPopup: boolean = true) => {
    if(isNumeric(groupIndex) && isNumeric(blockIndex) && isNumeric(index) && mainItem){
      let itm = _.cloneDeep(values.stepGroups[groupIndex].blocks[blockIndex].steps[index]);

      if(mainItem?.serviceItemId != itm?.serviceItemId){
        let obj = {
          ...itm,
          serviceItemId: mainItem?.serviceItemId,
          serviceItemName: mainItem?.serviceTag,
          serviceItem: mainItem,
        }
        await setFieldValue('stepGroups.' + groupIndex + '.blocks.' + blockIndex + '.steps.' + index, obj);

        let oldPricings = (values.pricings && values.pricings.length > 0) ? _.cloneDeep(values.pricings) : [];
        oldPricings = oldPricings.filter((x: any) => x.serviceTag != itm?.serviceItem?.serviceTag);

        let newPricings = setPricingsData(mainItem, additionalItems, itm?.stepOrder, true);
        let pricings = margePricingsData(oldPricings, newPricings);
        await setFieldValue('pricings', pricings);

        let amountToCollect = calcAmountToCollectFromPricings(pricings);
        await setFieldValue('amountToCollect', amountToCollect);
      }
    }
  }
  const onSelectAdditional = async (mainItem: any, additionalItems: Array<any>) => {
    let arr: Array<any> = [];

    if(mainItem){
      arr.push(mainItem);
    }
    if(additionalItems && additionalItems.length > 0){
      additionalItems.forEach((itm: any) => {
        arr.push(itm);
      })
    }

    let prevPricings = (values.pricings && values.pricings.length > 0) ? _.cloneDeep(values.pricings).filter((x: any) => !((x.serviceType === ServiceType.AdditionalService) && !(x.bundleServiceTag != ''))) : [];
    let oldPricings = (values.pricings && values.pricings.length > 0) ? _.cloneDeep(values.pricings).filter((x: any) => (x.serviceType === ServiceType.AdditionalService) && !(x.bundleServiceTag != '')) : [];

    let updatedPricings = oldPricings.filter((pricing: any) => {
      return arr.some((item: any) => item.serviceItemId === pricing.serviceItemId);
    });

    arr.forEach((service: any) => {
      const exists = updatedPricings.some((pricing: any) => pricing.serviceItemId === service.serviceItemId);
      if (!exists) {
        const newPricing = setPricingsData(service, [], null, true);
        updatedPricings = margePricingsData(updatedPricings, newPricing);
      }
    });

    let newPricings = [...prevPricings, ...updatedPricings];
    await setFieldValue('pricings', newPricings);

    let amountToCollect = calcAmountToCollectFromPricings(newPricings);
    await setFieldValue('amountToCollect', amountToCollect);
  }

  const onAddNew = async (groupIndex: number, blockIndex: number) => {
    if(isNumeric(groupIndex) && isNumeric(blockIndex)){
      let newPricings = updateBundleServiceTagsAfterAdd(values);
      await setFieldValue('pricings', newPricings);
    }
  }
  const onRemoveBin = async (groupIndex: number, blockIndex: number, index: number, item: any) => {
    if(isNumeric(groupIndex) && isNumeric(blockIndex) && isNumeric(index) && item){
      let isExchange1 = (values?.stepGroups?.[groupIndex]?.type === LocalJobType.EXCHANGE1) ? true : false;
      let isFor = (values?.stepGroups?.[groupIndex]?.blocks?.[blockIndex]?.isForWith === ForWith.FOR) ? true : false;

      let itm = item;
      let bIndex = blockIndex;
      if(isExchange1 && isFor){
        bIndex = blockIndex + 1;
        itm = values?.stepGroups?.[groupIndex]?.blocks?.[bIndex]?.bins?.[index]
      }
      
      let order = jobBinTypesOrder(values, groupIndex, bIndex, index, itm);
      let bundleServiceTag = itm?.serviceItem?.serviceTag + '_' + order;
      let newPricings = updateBundleServiceTagsAfterDelete(values, bundleServiceTag, isExchange1);

      await setFieldValue('pricings', newPricings);

      let amountToCollect = calcAmountToCollectFromPricings(newPricings);
      await setFieldValue('amountToCollect', amountToCollect);
    }
  }
  const onClearBin = async (groupIndex: number, blockIndex: number, index: number) => {
    if(isNumeric(groupIndex) && isNumeric(blockIndex) && isNumeric(index)){
      let itm = _.cloneDeep(values.stepGroups[groupIndex].blocks[blockIndex].bins[index]);
      let obj = {
        ...itm,
        serviceItem: null,
        serviceItemId: null,
        binTypeId: null,
        binType: null,
        isNoninventory: false,
        wasteTypeId: null,
        wasteType: null,
        wasteTypes: [],
        binNumberId: null,
        binNumber: '',
        quantity: 1,
        binOutWeight: null,
        binWeight: null,
        tareBinWeight: null,
        netBinWeight: null,
        nonBillableBinWeight: null,
        billableBinWeight: null,
        weightChitTicketNumber: null,
        weightChitRemarks: null,
        binWeighBy: null,
        weightChitDateTime: null,
        weightChitOutDateTime: null,
      }
      await setFieldValue('stepGroups.' + groupIndex + '.blocks.' + blockIndex + '.bins.' + index, obj);
      
      let order = jobBinTypesOrder(values, groupIndex, blockIndex, index, itm);

      let oldPricings = (values.pricings && values.pricings.length > 0) ? _.cloneDeep(values.pricings) : [];
      let newPricings = oldPricings.filter((x: any) => x.bundleServiceTag != itm?.serviceItem?.serviceTag + '_' + order);
      await setFieldValue('pricings', newPricings);

      let amountToCollect = calcAmountToCollectFromPricings(newPricings);
      await setFieldValue('amountToCollect', amountToCollect);
    }
  }

  const onChangeWasteTypes = async (groupIndex: number, blockIndex: number, index: number, item: any, removedServices: any, addedServices: any, unchangedServices: any) => {
    if(isNumeric(groupIndex) && isNumeric(blockIndex) && isNumeric(index) && item){
      let binTypeOrder = jobBinTypesOrder(values, groupIndex, blockIndex, index, item);

      let serviceItemdIds: Array<any> = [];
      let removedWasteTypeIds: Array<any> = [];
      let addedWasteTypeIds: Array<any> = [];

      if(removedServices && removedServices.length > 0){
        removedServices.forEach((x: any) => {
          if(x){
            if(isNumeric(x.serviceItemId)){
              serviceItemdIds.push(x.serviceItemId);
            } else {
              if(isNumeric(x.wasteTypeId)){
                removedWasteTypeIds.push(x);
              }
            }
          }
        });
      }

      if(addedServices && addedServices.length > 0){
        addedServices.forEach((x: any) => {
          if(x){
            if(isNumeric(x.serviceItemId)){
              serviceItemdIds.push(x.serviceItemId);
            } else {
              if(isNumeric(x.wasteTypeId)){
                addedWasteTypeIds.push(x);
              }
            }
          }
        });
      }

      
      let result = null;
      if(serviceItemdIds && serviceItemdIds.length > 0){
        result = new Promise((resolve) => {
          dispatch(servicesSlice.callDetailsServicesItemsApi(serviceItemdIds, (state: boolean, selectedServices: any) => {
            if(state){
              let services = (selectedServices && selectedServices.length > 0) ? selectedServices : [];
              let removed = services.filter((x: any) => removedServices.map((y: any) => y?.serviceItemId).includes(x.serviceItemId));
              let added = services.filter((x: any) => addedServices.map((y: any) => y?.serviceItemId).includes(x.serviceItemId));

              resolve({
                removed: removed,
                added: added,
              });
            } else {
              resolve({
                removed: [],
                added: [],
              });
            }
          }));
        });
      }


      let removedArr: Array<any> = [];
      let addedArr: Array<any> = [];
      if(result){
        result.then((res: any) => {
          if(res){
            removedArr = (res.removed && res.removed.length > 0) ? res.removed : [];
            addedArr = (res.added && res.added.length > 0) ? res.added : [];
          } else {
            removedArr = []
            addedArr = []
          }

          onChangeWasteUpdatePricings(removedArr, addedArr, removedWasteTypeIds, addedWasteTypeIds, item, binTypeOrder);
        })
      } else {
        onChangeWasteUpdatePricings(removedArr, addedArr, removedWasteTypeIds, addedWasteTypeIds, item, binTypeOrder)
      }
    }
  }
  const onChangeWasteUpdatePricings = async (removedServices: any, addedServices: any, removedWasteTypes: any, addedWasteTypes: any, item: any, binTypeOrder: any) => {
    let binTypeId = (item && isNumeric(item?.binTypeId)) ? item?.binTypeId : null;
    let oldPricings = (values.pricings && values.pricings.length > 0) ? _.cloneDeep(values.pricings) : [];


    if(removedWasteTypes && removedWasteTypes.length > 0){
      removedWasteTypes.forEach((x: any) => {
        if(x && isNumeric(x?.wasteTypeId)){
          oldPricings = oldPricings.filter((y: any) => !(y?.binTypeId == binTypeId && y?.wasteTypeId == x?.wasteTypeId));
        }
      });
    }


    if(removedServices && removedServices.length > 0){
      removedServices.forEach((x: any) => {
        if(x && isNumeric(x.serviceItemId)){
          let bundleServices = (x && x.bundleServices && x.bundleServices.length > 0) ? x.bundleServices : [];

          if(bundleServices && bundleServices.length > 0){
            bundleServices.forEach((k: any) => {
              if(k && isNumeric(k.serviceItemId)){
                oldPricings = oldPricings.filter((z: any) => (z?.serviceItemId != k?.serviceItemId));
              }
            });
          }

          oldPricings = oldPricings.filter((y: any) => (y?.serviceItemId != x?.serviceItemId));
        }
      });
    }


    if(addedServices && addedServices.length > 0){
      addedServices.forEach((x: any) => {
        let addedServicesObject = setPricingItem(x, binTypeOrder, false, null);

        if(addedServicesObject && addedServicesObject.main){
          oldPricings.push(addedServicesObject?.main);

          if(addedServicesObject?.bundle && addedServicesObject?.bundle.length > 0){
            addedServicesObject?.bundle.forEach((bundleItem: any) => {
              oldPricings.push(bundleItem);
            })
          }
        }
      })
    }


    if(addedWasteTypes && addedWasteTypes.length > 0){
      addedWasteTypes.forEach((x: any) => {
        if(x && isNumeric(x?.wasteTypeId)){
          let itm = setPricingItemWithoutService(x, item, binTypeOrder);

          if(itm){
            oldPricings.push(itm);
          }
        }
      });
    }

    let pricings = margePricingsData(oldPricings, []);
    

    await setFieldValue('pricings', pricings);

    let amountToCollect = calcAmountToCollectFromPricings(pricings);
    await setFieldValue('amountToCollect', amountToCollect);
  }

  const onChangeQuantity = async (groupIndex: number, blockIndex: number, index: number, item: any, value: any) => {
    let pricings = (values.pricings && values.pricings.length > 0) ? _.cloneDeep(values.pricings) : [];
    let ind = pricings.findIndex((x: any) => x.serviceItemId == item?.serviceItemId);
    if(ind > -1){
      pricings[ind].quantity = value;
      await setFieldValue('pricings', pricings);

      let amountToCollect = calcAmountToCollectFromPricings(pricings);
      await setFieldValue('amountToCollect', amountToCollect);
    }
  }
  const convertQtyinPricings = async (val: any) => {
    let bins: any = getBinsForPricings(val);
    if(bins && bins.length > 0){
      let newPricings: Array<any> = _.cloneDeep(values?.pricings);

      bins.forEach((item: any) => {
        let qty = smartConversionKgTons(item?.billableBinWeight);
        newPricings = setQtyAtMainPricings(newPricings, item, qty);
      });

      await setFieldValue('pricings', newPricings);

      let amountToCollect = calcAmountToCollectFromPricings(newPricings);
      await setFieldValue('amountToCollect', amountToCollect);
    }

    if (isEdit() && !isCopy()) {
      setWeightChitCounter(weightChitCounter + 1);
    }
  }

  const calcAmountToCollectFromPricings = (pricings: Array<any>) => {
    let totalObj = getTotal(values, [], 'pricings');
    return isNumeric(totalObj?.balance) ? totalObj?.balance.toFixed(2) : null;
  }

  const setCustomerSite = async (option: any, groupIndex: any, customerIndex: any) => {
    if(option){
      let customerSiteItem = _.cloneDeep(customerSiteInit);
      customerSiteItem['customerSiteId'] = option?.customerSiteId;
      customerSiteItem['customerSiteName'] = option.siteNameDisplay;
      customerSiteItem['site'] = option;

      await setFieldValue('stepGroups.' + groupIndex + '.customerSites.' + customerIndex, customerSiteItem);

      let count = 0;
      let group = _.cloneDeep(values.stepGroups[groupIndex]);
      if(group && group.blocks && group.blocks.length > 0){
        group.blocks.forEach((blockItem: any, blockIndex: number) => {
          
          if(blockItem && blockItem.steps && blockItem.steps.length > 0){
            let blockStepsArr: Array<any> = [];
            blockItem.steps.forEach((stepItem: any) => {
              if(stepItem?.locationType === LocationEnum.CustomerSite){
                if(count == customerIndex){
                  blockStepsArr.push({
                    ...stepItem,
                    address: customerSiteItem?.address || '',
                    fullAddress: customerSiteItem?.fullAddress || '',
                    latitude: customerSiteItem?.latitude || '',
                    longitude: customerSiteItem?.longitude || '',
                    customerSiteId: customerSiteItem?.customerSiteId || null,
                    customerSiteName: customerSiteItem?.customerSiteName || '',
                    site: customerSiteItem?.site || null,
                    siteName: customerSiteItem?.siteName || '',
                    siteRemarks: customerSiteItem?.instructions || '',
                    contactNumberOne: customerSiteItem?.contactPersonName || '',
                    contactNumberTwo: customerSiteItem?.contactPersonNameTwo || '',
                    contactPersonOne: customerSiteItem?.contactPersonName || '',
                    contactPersonTwo: customerSiteItem?.contactPersonNameTwo || '',
                  }); 
                } else {
                  blockStepsArr.push({
                    ...stepItem,
                    address: '',
                    fullAddress: '',
                    latitude: '',
                    longitude: '',
                    customerSiteId: null,
                    customerSiteName: '',
                    site: null,
                    siteName: '',
                    siteRemarks: '',
                    contactNumberOne: '',
                    contactNumberTwo: '',
                    contactPersonOne: '',
                    contactPersonTwo: '',
                  });
                }

                count = count + 1;
              } else {
                blockStepsArr.push(stepItem);
              }
            });
            
            setFieldValue('stepGroups.' + groupIndex + '.blocks.' + blockIndex + '.steps', blockStepsArr);
          }
        });
      }

      if(option){
        let remarks = (option && option.remarks && option.remarks !== '') ? option.remarks : '';
        let instructions = (option && option.instructions && option.instructions !== '') ? option.instructions : '';
        let contactPersonName = (option && option.contactPersonName && option.contactPersonName !== '') ? option.contactPersonName : '';
        let contactPersonPhoneNumber = (option && option.contactPersonPhoneNumber && option.contactPersonPhoneNumber !== '') ? option.contactPersonPhoneNumber : '';
        let contactPersonNameTwo = (option && option.contactPersonNameTwo && option.contactPersonNameTwo !== '') ? option.contactPersonNameTwo : '';
        let contactPersonPhoneNumberTwo = (option && option.contactPersonPhoneNumberTwo && option.contactPersonPhoneNumberTwo !== '') ? option.contactPersonPhoneNumberTwo : '';
        
        let isContactPersonSendNotification = ((option.isContactPersonSendNotification === false) || (option.isContactPersonSendNotification === true)) ? option.isContactPersonSendNotification : false;
        let isContactPersonTwoSendNotification = ((option.isContactPersonTwoSendNotification === false) || (option.isContactPersonTwoSendNotification === true)) ? option.isContactPersonTwoSendNotification : false;

        let copySiteRemarksToJob = (option && ((option.copySiteRemarksToJob == false) || (option.copySiteRemarksToJob == true))) ? option.copySiteRemarksToJob : false;
        
        // let weekdaysAvailability = (option && option.weekdaysAvailability) ? option.weekdaysAvailability : CustomerSiteAvailability.All;
        // let weekendAvailability = (option && option.weekendAvailability) ? option.weekendAvailability : CustomerSiteAvailability.All;
        
        let defaultDrivers = (option.defaultDrivers && option.defaultDrivers.length > 0) ? option.defaultDrivers : [];
        if(defaultDrivers && defaultDrivers.length > 0){
          let defArr = defaultDrivers.filter((x: any) => x.defaultVehicle !== null);
          if(defArr && defArr.length > 0){
            let driverItem = defArr[0];
            let driverId = (driverItem.driverId && driverItem.driverId > 0) ? driverItem.driverId : null;
            let driverName = (driverItem.driverName && driverItem.driverName !== '') ? driverItem.driverName : '';
            
            if(values.driverId === null || values.driverId <= 0){
              await setFieldValue('driverId', driverId);
              await setFieldValue('driverName', driverName);
            }

            let vehicleItem = defArr[0].defaultVehicle;
            let vehicleId = (vehicleItem.vehicleId && vehicleItem.vehicleId > 0) ? vehicleItem.vehicleId : null;
            let vehicleName = (vehicleItem.vehicleName && vehicleItem.vehicleName !== '') ? vehicleItem.vehicleName : '';
            
            if(values.vehicleId === null || values.vehicleId <= 0){
              await setFieldValue('vehicleId', vehicleId);
              await setFieldValue('vehicleName', vehicleName);

              let selectedStatus = findStatus(values?.jobTemplate?.templateStatuses, 'unassigned');
              if (values.statusId === null || values.statusId === 0 || values.statusId === selectedStatus.jobStatusId) {
                let newStatus = findStatus(values?.jobTemplate?.templateStatuses, 'assigned');
                let newStatusId = (newStatus.jobStatusId) ? newStatus.jobStatusId : null;
                let newStatusName = (newStatus.jobStatusName) ? newStatus.jobStatusName : '';
                
                await setFieldValue('statusId', newStatusId);
                await setFieldValue('statusName', newStatusName);
              }
            }
          }
        }
        let prevRemarks = (values.stepGroups && values.stepGroups[groupIndex] && values.stepGroups[groupIndex].length > 0 && values.stepGroups[groupIndex].customerSite && values.stepGroups[groupIndex].customerSite[customerIndex] && values.stepGroups[groupIndex].customerSite[customerIndex].remarks && values.stepGroups[groupIndex].customerSite[customerIndex].remarks != '') ? values.stepGroups[groupIndex].customerSite[customerIndex].remarks : '';
        let newRemarks = concatStringRemarks(values.remarks, remarks, prevRemarks, copySiteRemarksToJob);
        await setFieldValue('remarks', newRemarks);
        
        await setFieldValue('stepGroups.' + groupIndex + '.customerSites.' + customerIndex + '.instructions', instructions);
        await setFieldValue('stepGroups.' + groupIndex + '.customerSites.' + customerIndex + '.contactPersonName', contactPersonName);
        await setFieldValue('stepGroups.' + groupIndex + '.customerSites.' + customerIndex + '.contactPersonPhoneNumber', contactPersonPhoneNumber);
        await setFieldValue('stepGroups.' + groupIndex + '.customerSites.' + customerIndex + '.contactPersonNameTwo', contactPersonNameTwo);
        await setFieldValue('stepGroups.' + groupIndex + '.customerSites.' + customerIndex + '.contactPersonPhoneNumberTwo', contactPersonPhoneNumberTwo);
        await setFieldValue('stepGroups.' + groupIndex + '.customerSites.' + customerIndex + '.isContactPersonSendNotification', isContactPersonSendNotification);
        await setFieldValue('stepGroups.' + groupIndex + '.customerSites.' + customerIndex + '.isContactPersonTwoSendNotification', isContactPersonTwoSendNotification);
        await setFieldValue('stepGroups.' + groupIndex + '.customerSites.' + customerIndex + '.address', formatCustomerSiteAddress(option));
        await setFieldValue('stepGroups.' + groupIndex + '.customerSites.' + customerIndex + '.latitude', option?.latitude);
        await setFieldValue('stepGroups.' + groupIndex + '.customerSites.' + customerIndex + '.longitude', option?.longitude);
      }
    }
  }

  const onSaveAction = (eventKey: any) => {
    saveJobForm(eventKey, getId(), formik, values?.jobTemplate, 
      () => {
        onCreate(eventKey);
      },
      () => {
        onUpdate(eventKey);
      },
      () => {
        onCopy(eventKey)
      },
      () => {
        // onCachCollected
        dispatch(confirmSlice.show(() => {
          onUpdate(eventKey);
          dispatch(confirmSlice.setHide());
        }, {
          title: 'Cash collected Info',
          body: 'Cash collected by driver is less than amount to be collected. Do you want to continue?',
          size: 'md',
          cancelText: 'No',
          cancelVariant: 'custom-outlined',
          cancelCallback: () => {},
          confirmText: 'Yes',
          confirmVariant: 'custom-primary',
        }));
      },
      () => {
        // onCanceled
        dispatch(confirmSlice.show(null, {
          title: 'Are you sure you want to cancel this job?',
          body: <>
            <Form.Group>
              <Form.Control
                as="textarea"
                className='textarea-noresize'
                id="jobform_cancel_remarksID"
                autoFocus
                rows={5}
                autoComplete='off'
                placeholder={'Enter cancellation remarks'}
                disabled={false}
              />
              <Form.Control.Feedback type="invalid">You must enter cancellation remarks</Form.Control.Feedback>
            </Form.Group>
          </>,
          size: 'md',
          cancelText: 'No',
          cancelVariant: 'custom-outlined',
          cancelCallback: () => {},
          confirmText: 'Yes',
          confirmVariant: 'custom-danger',
          confirmCallback: async () => {
            const input = document.getElementById('jobform_cancel_remarksID') as HTMLTextAreaElement | null;
            if(input){
              if(input.value !== ''){
                input.classList.remove("is-invalid");
                let val: any = input.value;

                onUpdate(eventKey, val);
                dispatch(confirmSlice.setHide());
              } else {
                input.classList.add("is-invalid");
              }
            }
          },
        }));
      }
    );
  }


  const setLayout = () => {
    return <StyledLayoutWrapper>
      <div id={'top_ID'} className='top-section'>
        <Header
          onCancel={() => {
            onCancel();
          }}
        />
      </div>

      <div id={'content_ID'} className='content-section'>
        <div className='form-section'>
          <Row className='gy-32 align-items-center'>
            <Alerts
              onUpdatePrice={() => {
                dispatch(confirmSlice.show(null, {
                  closeButton: false,
                  title: 'Update to New Price',
                  body: 'Are you sure you want to update the new prices?',
                  size: 'md',
                  cancelText: 'No',
                  cancelVariant: 'custom-outlined',
                  cancelCallback: () => {
                    setFieldValue('promptUpdateBilling', false);
                  },
                  confirmText: 'Yes',
                  confirmVariant: 'custom-primary',
                  confirmCallback: async () => {
                    let customerSites = getFirstCustomerSite(values);
                    dispatch(billingJobSlice.callUpdateBillingApi({ customerId: values?.customerId, customerSiteId: customerSites?.customerSiteId }, async (state: boolean, data: any) => {
                      if(state){
                        let arr = (data && data.data && data.data.length > 0) ? data.data : [];
                        let pricingsArr: Array<any> = updateBillingPricings(values, arr);
                        await setFieldValue('pricings', pricingsArr);
                        
                        await setFieldValue('promptUpdateBilling', false);
                        dispatch(confirmSlice.setHide());
                      }
                    }));
                  },
                }));
              }}
            />
            <CustomerDetails />
            {values.customerId && <JobType ref={jobTypeRef} />}
            {values.jobTemplateId && <Location />}
            {!isCreditLimit && <>
              {values.jobTemplateId && <BinDetails
                onCopyToBelowSection={async (groupIndex: number, blockIndex: number, index: number, mainItem: any, additionalItems: any, item: any) => {
                  if(item){
                    onSelectBin(groupIndex, blockIndex, index, null, mainItem, additionalItems, false);
                  } else {
                    onClearBin(groupIndex, blockIndex, index);
                  }
                }}
                onRemoveBin={(groupIndex: number, blockIndex: number, index: number, item: any) => {
                  onRemoveBin(groupIndex, blockIndex, index, item);
                }}
                onAddNew={(groupIndex: number, blockIndex: number) => {
                  onAddNew(groupIndex, blockIndex);
                }}
                onChangeQuantity={async (groupIndex: number, blockIndex: number, index: any, item: any, value: any) => {
                  onChangeQuantity(groupIndex, blockIndex, index, item, value);
                }}
                onChangeWasteTypes={async (groupIndex: number, blockIndex: number, index: number, item: any, removedServices: any, addedServices: any, unchangedServices: any) => {
                  onChangeWasteTypes(groupIndex, blockIndex, index, item, removedServices, addedServices, unchangedServices);
                }}
              />}
              {values.jobTemplateId && <DispatchOrder />}
              {values.jobTemplateId && <Payment
                showDivider={(values.jobTemplateId && isEdit() && !isCopy())}
                onChangeCollectPayment={async () => {
                  let amountToCollect = calcAmountToCollectFromPricings(values?.pricings);
                  await setFieldValue('amountToCollect', amountToCollect);
                }}
              />}
              {(values.jobTemplateId && isEdit() && !isCopy()) && <Attachments />}
              {(values.jobTemplateId && isEdit() && !isCopy()) && <Signature />}
              {(values.jobTemplateId && isEdit() && !isCopy()) && <AuditTrailList />}
            </>}
          </Row>
        </div>

        <div className='side-section'>
          <Row className='gy-32 align-items-center'>
            <JobRoutes />
          </Row>
        </div>
      </div>

      <div id={'footer_ID'} className='footer-section'>
        <Footer
          onSave={async (eventKey: any) => {
            onSaveAction(eventKey);
          }}
          onSaveCopyDraft={async (eventKey: any) => {
            onCopy(eventKey)
          }}
        />
      </div>
    </StyledLayoutWrapper>
  }


  return <MainContainer className={'p-0'} title={'Job form'} isLoading={false} roles={Permissions.Jobs}>
    <FormikContext.Provider value={formik}>
      <Spin spinning={(
        isLoading || 
        isLoadingCreateUpdateDelete || 
        isLoadingCreditLimit || 
        isLoadingJobTemplates ||
        isLoadingDownloadInternalNote || 
        isLoadingRefreshJobNote ||
        isLoadingServicesItems
      )} wrapperClassName={'no-height'}>{setLayout()}</Spin>
    </FormikContext.Provider>

    <JobTypeHistory
      onSave={(selectedId: number|null, selectedItem: any) => {
        if(jobTypeRef && jobTypeRef.current){
          jobTypeRef.current.onSelectTemplate(selectedItem);
        }
      }}
    />

    <DefaultLocation
      onSave={async (groupIndex: number, blockIndex: number, stepIndex: number, step: any, values: any, hasDefaultSite: boolean) => {
        if(isNumeric(groupIndex) && isNumeric(blockIndex) && isNumeric(stepIndex) && step){
          await setFieldValue('stepGroups.' + groupIndex + '.blocks.' + blockIndex + '.steps.' + stepIndex + '.defaultLocationId', hasDefaultSite ? values?.defaultLocationId : null);
          await setFieldValue('stepGroups.' + groupIndex + '.blocks.' + blockIndex + '.steps.' + stepIndex + '.defaultLocation', hasDefaultSite ? values?.defaultLocation : null);
          await setFieldValue('stepGroups.' + groupIndex + '.blocks.' + blockIndex + '.steps.' + stepIndex + '.siteName', values?.locationName);
          await setFieldValue('stepGroups.' + groupIndex + '.blocks.' + blockIndex + '.steps.' + stepIndex + '.address', values?.address);
          await setFieldValue('stepGroups.' + groupIndex + '.blocks.' + blockIndex + '.steps.' + stepIndex + '.fullAddress', values?.address);
          await setFieldValue('stepGroups.' + groupIndex + '.blocks.' + blockIndex + '.steps.' + stepIndex + '.latitude', values?.latitude);
          await setFieldValue('stepGroups.' + groupIndex + '.blocks.' + blockIndex + '.steps.' + stepIndex + '.longitude', values?.longitude);
          await setFieldValue('stepGroups.' + groupIndex + '.blocks.' + blockIndex + '.steps.' + stepIndex + '.hasDefaultSite', hasDefaultSite);
          await setFieldValue('stepGroups.' + groupIndex + '.blocks.' + blockIndex + '.steps.' + stepIndex + '.isSaveDefaultLocation', values?.isSaveDefaultLocation);
        }
      }}
    />

    <Services
      ref={serviceListRef}
      onSave={async (groupIndex: number, blockIndex: number, index: number, selectedItem: any, mainItem: any, additionalItems: Array<any>, tab: any, isTask: boolean, isAdditional: boolean) => {
        if(isTask){
          onSelectTask(groupIndex, blockIndex, index, mainItem, additionalItems, true);
        } else if(isAdditional){
          onSelectAdditional(mainItem, additionalItems);
        } else {
          onSelectBin(groupIndex, blockIndex, index, selectedItem, mainItem, additionalItems, true);
        }
      }}
    />
    
    <DriverOptions
      onSave={(steps: Array<any>) => {
        setFieldValue('steps', steps);
      }}
    />

    <BillingJob
      onSave={async (val: any) => {
        await setFieldValue('isBillable', val?.isBillable);
        await setFieldValue('invoiceDate', val?.invoiceDate);
        await setFieldValue('billingNote', val?.billingNote);
        await setFieldValue('pricings', val?.pricings);

        await setFieldValue('amountToCollect', val?.proformaInvoiceTotal);
        await setFieldValue('proformaInvoiceTotal', val?.proformaInvoiceTotal);
        await setFieldValue('proformaPaymentMethodMetaId', val?.proformaPaymentMethodMetaId);
        await setFieldValue('proformaPaymentMethodMetaName', val?.proformaPaymentMethodMetaName);
        await setFieldValue('proformaPaymentType', val?.proformaPaymentType);
        await setFieldValue('proformaPaymentReceived', val?.proformaPaymentReceived);
        await setFieldValue('proformaInvoiceDate', val?.proformaInvoiceDate);
        await setFieldValue('proformaInvoiceStatus', val?.proformaInvoiceStatus);
        await setFieldValue('proformaPricings', val?.proformaPricings);

        await setFieldValue('amountToCollect', val?.amountToCollect);
        if(val?.proformaPaymentType == ProformaPaymentType.CollectedByDriver){
          await setFieldValue('isRequirePaymentCollection', true);
          await setFieldValue('collectedAmount', val?.proformaPaymentReceived);
        } else {
          await setFieldValue('isRequirePaymentCollection', false);
        }
      }}
    />

    <WeightChit
      onSave={async (val: any) => {
        await setFieldValue('stepGroups', val?.stepGroups);
        await convertQtyinPricings(val);
      }}
    />

    <JobSummary />
    <PrintPreview />
    <RecurringJob />
    <AuditTrail />
    <AuditTrailDriverTrackng />
    <ProformaInvoice />

    <ServicesForm
      backdropClassName={'z-index-1045'}
      onSave={(data: any) => {
        if(serviceListRef && serviceListRef.current){
          serviceListRef.current.addNewItem(data);
        }
      }}
    />

    <CustomerMiniForm
      onSave={async (res: any) => {
        if(res){
          let newValues = clearForm({
            customerId: res?.customerId,
            customerName: res?.customerName,
            customer: res,
          });
          await setValues(newValues);

          dispatch(slice.clearDistance());
          dispatch(slice.clearTotal());

          if (isCopy() || !isEdit()) {
            dispatch(slice.callReadCheckCreditLimitApi(res?.customerId, (state: boolean, data: any) => {}));
          }
        }
      }}
    />

    <CustomerSiteMiniForm
      onSave={async (option: any, groupIndex: any, customerIndex: any) => {
        await setCustomerSite(option, groupIndex, customerIndex);
      }}
    />

    <DeleteJob
      onDelete={(remarks: any) => {
        onDelete(remarks)
      }}
    />

    <SignalR
        url={REACT_APP_REAL_TIME_URL}
        group={groupAccountEmail}
        onConnect={() => { }}
        onFailed={(err: any) => { }}
        onReceiveMessage={(type: any, msg: any) => {
          if (type === ReceiveMessage.UpdateBatchJob) {
            if(msg && msg.successJobs && msg.successJobs.length > 0){
              for(let i = 0; i < msg.successJobs.length; i++){
                let job = msg.successJobs[i];
                let jobInfo = job?.job;

                if (userEmail !== jobInfo?.updatedBy) {
                  if (getId() === jobInfo?.jobId) {
                    dispatch(slice.setIsJobUpdated(true));
                    break;
                  }
                }
              }
            }
          }
        }}
      />
  </MainContainer>
}

export default FormComponent;
